const TOKEN_KEY = 'ACCESS_TOKEN';
const SESSION_VALID_KEY = 'SESSION_VALID';
const USER_ID = 'USER_ID';
const USER_ROLE = 'USER_ROLE';
const USER_NAME = 'USER_NAME';
const USER_GROUP_ID = 'USER_GROUP_ID';
const USER_PRIORITY = 'USER_PRIORITY';
const DEVICE_ID = 'DEVICE_ID';
import { authEvents } from './authEvents';
export const sessionManager = {
  setToken(token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  },

  getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  setDeviceId(deviceId) {
    sessionStorage.setItem(DEVICE_ID, deviceId);
  },

  getDeviceId() {
    return sessionStorage.getItem(DEVICE_ID);
  },


  setUserInfo(userInfo) {
    if (userInfo.userId !== undefined)
      sessionStorage.setItem(USER_ID, userInfo.userId);
    if (userInfo.userRole !== undefined)
      sessionStorage.setItem(USER_ROLE, userInfo.userRole);
    if (userInfo.userName !== undefined)
      sessionStorage.setItem(USER_NAME, userInfo.userName);
    if (userInfo.userGroupId !== undefined)
      sessionStorage.setItem(USER_GROUP_ID, userInfo.userGroupId);
    if (userInfo.userPriority !== undefined)
      sessionStorage.setItem(USER_PRIORITY, userInfo.userPriority);
  },

  setUserId(userId) {
    sessionStorage.setItem(USER_ID, userId);
  },

  setUserRole(userRole) {
    sessionStorage.setItem(USER_ROLE, userRole);
  },

  setUserName(userName) {
    sessionStorage.setItem(USER_NAME, userName);
  },

  setUserGroupId(userGroupId) {
    sessionStorage.setItem(USER_GROUP_ID, userGroupId);
  },

  setUserPriority(userPriority) {
    sessionStorage.setItem(USER_PRIORITY, userPriority);
  },

  getUserId() {
    return sessionStorage.getItem(USER_ID);
  },

  getUserRole() {
    return sessionStorage.getItem(USER_ROLE);
  },

  getUserName() {
    return sessionStorage.getItem(USER_NAME);
  },

  getUserGroupId() {
    return sessionStorage.getItem(USER_GROUP_ID);
  },

  getUserPriority() {
    return sessionStorage.getItem(USER_PRIORITY);
  },

  getUserInfo() {
    return {
      userId: sessionStorage.getItem(USER_ID),
      userRole: sessionStorage.getItem(USER_ROLE),
      userName: sessionStorage.getItem(USER_NAME),
      userGroupId: sessionStorage.getItem(USER_GROUP_ID),
      userPriority: sessionStorage.getItem(USER_PRIORITY),
    };
  },

  clearUserInfo() {
    sessionStorage.removeItem(USER_ID);
    sessionStorage.removeItem(USER_ROLE);
    sessionStorage.removeItem(USER_NAME);
    sessionStorage.removeItem(USER_GROUP_ID);
    sessionStorage.removeItem(USER_PRIORITY);
  },

  clearSession() {
    sessionStorage.clear();
  },

  markSessionValid() {
    sessionStorage.setItem(SESSION_VALID_KEY, 'true');
  },

  isSessionValid() {
    return sessionStorage.getItem(SESSION_VALID_KEY) === 'true';
  },

  cleanupAndRedirect() {
    this.clearSession();
    authEvents.reset();
  },
};
